module.exports = __webpack_public_path__ + "img/featured.9b2162e5.png";